import React from 'react';
import AddVideoPackagePaymentSettingComponent from '../../../Components/VideoPackagePaymentSetting/AddVideoPackagePaymentSetting';

export default function AddVideoPackagePaymentSetting() {
    return (
        <div className='page-body'>
            <AddVideoPackagePaymentSettingComponent />
        </div>
    );
}